export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5610.7fb25424.jpg";